<script>
import { mapActions } from 'vuex'
import WidgetCard from '@widgets/widget-card.vue'
import getSeasons from '@utils/seasons'

export default {
  components: {
    WidgetCard,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
    },
    sheetClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      header: [
        {
          text: this.$t('season_history.season'),
          value: 'season',
        },
        {
          text: this.$t('tournament'),
          value: 'tournament',
        },
        {
          text: this.$t('team'),
          value: 'team',
        },
        {
          text: this.$t('season_history.rank'),
          value: 'rank',
        },
      ],
      data: [],
    }
  },
  async mounted() {
    const seasons = getSeasons(5, new Date())
    const data = await Promise.all(
      seasons.map((season) => {
        return this.getSinglePlayerRankingData({
          id: this.playerId,
          season: season,
        }).catch((error) => {
          console.warn(error)
        })
      })
    )
    this.data = data.reduce((carry, season) => {
      if (typeof season !== 'undefined' && typeof season[0] !== 'undefined') {
        season = season[0]
        carry.push({
          season: season.season,
          tournament:
            season.tournament.charAt(0).toUpperCase() +
            season.tournament.slice(1),
          team: season.team,
          rank: season.ranking,
        })
      }

      return carry
    }, [])
  },
  methods: {
    ...mapActions('players', {
      getSinglePlayerRankingData: 'getSinglePlayerRankingData',
    }),
  },
}
</script>

<template>
  <WidgetCard :title="$t('season_history.title')" :sheet-class="sheetClass">
    <v-data-table
      class="v-data-table--font-xs"
      dense
      :headers="header"
      :items="data"
      :item-class="() => $style.seasonRow"
      :hide-default-footer="true"
    >
    </v-data-table>
  </WidgetCard>
</template>

<style lang="scss" module>
@import '@design';

.seasonRow {
  line-height: 1rem;
}
</style>
